import { z } from 'zod';
import { membershipRoleSchema } from '../roles.js';
export const memberSchema = z.object({
    membershipId: z.uuid(),
    userId: z.uuid(),
    email: z.string(),
    name: z.string().nullable(),
    role: membershipRoleSchema,
    isActive: z.boolean(),
    createdAt: z.iso.datetime(),
});
export const addMemberInputSchema = z.object({
    email: z.string().email().max(320),
    /** Если пользователя ещё нет, он создаётся с этим паролем. */
    password: z.string().min(10).max(200).optional(),
    name: z.string().max(200).optional(),
    role: membershipRoleSchema,
});
export const updateMemberRoleInputSchema = z.object({ role: membershipRoleSchema });
//# sourceMappingURL=members.js.map